var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "编辑公告",
        width: "606px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "editNotice overflowOuto",
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "auto" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公告内容", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 7, maxRows: 7 },
                      maxlength: "200",
                      "show-word-limit": "",
                      placeholder: "请输入公告内容",
                    },
                    model: {
                      value: _vm.form.value,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "value",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.value",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传图片", prop: "name" } },
                [
                  _c("uploadView", {
                    key: "MUpload",
                    ref: "MUpload",
                    attrs: {
                      width: 182,
                      height: 120,
                      accept: ".jpg,.jpeg,.png",
                      "upload-text": "上传图片",
                      "before-upload": _vm.beforeUploadImg,
                      "max-length": 1,
                      "get-oss-c-onfig-api": _vm.getLiveOssCConfig,
                      "oss-teacher-folder": "hok_liveRoom",
                    },
                    on: {
                      onClick: _vm.onImgClick,
                      change: (res) => _vm.fileChange(res),
                    },
                  }),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v("只支持PNG或JPG图片，限一张，大小限5M以内"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }